import { update as user } from './user';

export const reducers = {
  user,
};
